export const xbToken = state => state.xbToken

export const xbUserInfo = state => state.xbUserInfo

export const xbLoginStatus = state => state.xbLoginStatus

export const dbToken = state => state.dbToken

export const dbUserInfo = state => state.dbUserInfo

export const dbLoginStatus = state => state.dbLoginStatus
